import { PureComponent, createRef } from 'react'
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import _, { create } from 'lodash';
import * as selectors from './NewFeatureSelector';
import template from './NewFeatureOverlay.rt';
import {
  getActiveFeaturesForDDL,
  getFilteredFeatureGroups,
  getUnfilteredFeatureGroups
} from '../../ProjectScope/ProjectScopeSelector';
import { AccessRights } from '../../../schemas/accessRightsModel';
import { getFilteredPendingFeatureGroups } from "../../ProjectScope/NewFeatureGroup/NewFeatureGroupSelector";
import { PRODUCT_SORT_OPTIONS } from "../../Installations/InstallationGroupItems/NewInstallationGroupItem/NewInstallationOverlay";
import A from '../FeatureCreatorNewActions';
import { loadingDialog_show, errorBox_Show, messageBox_Show } from './../../../actions/A_Popups';
import { CUSTOMERS_INFO_CLEAR } from '../../../constants/actionTypes';
import { getFeatureData, getFeatureDataRelated, saveFeature, showNewFeatureOverlay, resetFeatureData } from "./NewFeatureActions";
import { STATES } from '../../Generic/checkBox3State';
import { getAllFilterGroups } from "../FeaturesFilters/FeaturesFiltersActions";
import { UNIT_MEASUREMENTS } from "../../../utilities";
import {AVAILABLE_VISUALIZERS} from "../../../constants/dashboard";

const CabinetSizes = [24, 30, 36, 48, 60, 72];
const ShowerSizes = [30, 60];

export const Steps = {
  Installation: { step: 0, text: 'Installation' },
  Filters: { step: 1, text: 'Filters' },
  Gallery: { step: 2, text: 'Gallery' },
  ComplexLogic: { step: 3, text: 'Complex Logic', unlinkedVisible: true },
  DisplayLogic: { step: 4, text: 'Display Logic', adminOnly: true },
  // Layers: {step: 5, text: 'Layers'},
  RelatedFeatures: { step: 6, text: 'Related Features' },
  GroupedFeaturesByName: { step: 7, text: 'Matching products' },
  BundledFeatures: { step: 8, text: 'Bundled Features' }
};

export const StepsFn = (feature, isNew) => {
  let steps = _.cloneDeep(Steps);
  // if (!feature || !feature.complex) {
  //   // delete steps.Layers;
  //   if (!feature || _.size(feature.groupedFeaturesByName) <= 1)
  //     delete steps.GroupedFeaturesByName;
  // }

  return steps;
}

export const DisplayLogicComparisonOptions = [
  { text: 'is less than', value: '<' },
  { text: 'is less than or equal to', value: '<=' },
  { text: 'is equal to', value: '=' },
  { text: 'is greater than or equal to', value: '>=' },
  { text: 'is greater than', value: '>' },
  { text: 'is selected in wizard', value: 'wizard' },
];

export const DisplayLogicActionOptions = [
  { text: 'Show', value: 'show' },
  { text: 'Hide', value: 'hide' }
]

export const GetTextFromDDLByValue = (ddlOptions, value) => {
  const selected = _.find(ddlOptions, o => o.value === value);
  if (selected) {
    return selected.text;
  }
  return 'N/A';
}

const mapStateToPropsNew = (state, props) => {
  const edit = selectors.getActiveEditData(state);
  const { newFeature, featuresCreatorNew, auth } = state;
  var hasUnlinkedData = false;
  if (edit) {
    hasUnlinkedData = !!edit.unlinkedData;
  }

  return {
    edit,
    AR: AccessRights.get(state),
    isServerData: true,
    group: {
      name: featuresCreatorNew.activeFeaturesGroupName
    },
    matchingProducts: newFeature.matchingProducts,
    unfilteredFeatureGroups: newFeature.lightFeaturesGroups,
    // filterGroups: newFeature.filterGroups,
    filterGroups: state.newFeature.featureDefinitionId ? state.newFeature.filterGroups : state.featuresFiltersState.allFilterGroups,
    hasKitchen: auth.hasKitchenSub,
    hasBathroom: auth.hasBathroomSub,
    hasFireplace: auth.hasFireplaceSub,
    hasLaundryRoom: auth.hasLaundryRoomSub,
    installationDDL: selectors.getInstallationDDLNew(state),
    featureDefinitionId: state.newFeature.featureDefinitionId,
    catId: state.routing.locationBeforeTransitions.query.catId,
    hasUnlinkedData,
    categoriesVisualizer: state.newScope.categoriesVisualizer,
    fabricatorId: state.asCustomer && state.asCustomer.data ? state.asCustomer.data.fabricatorId : state.auth.fabricatorId,
    bundledFeaturesQuantities: newFeature.bundledFeaturesQuantities
  }
}

const mapStateToProps = (state, props) => {
  if (selectors.getIsServerData(state)) {
    return mapStateToPropsNew(state, props);
  }
  // let featureList = [{text: "Material", value: "-1"}, ...getActiveFeaturesForDDL(state)];
  // the actual properties are set via the NewFeaturesReducer, not from the API result!
  const edit = selectors.getActiveEditData(state);
  const { featuresCreatorNew, auth } = state;
  const featureGroups = getFilteredFeatureGroups(state);
  const unfilteredFeatureGroups = getUnfilteredFeatureGroups(state);
  const pendingFeatureGroups = getFilteredPendingFeatureGroups(state);

  const allFeatureGroups = _.sortBy(_.union(featureGroups, pendingFeatureGroups),
    a => _.trim(a.name).toLowerCase())
    .filter(g => !_.isEmpty(g.features) && g.enabled);
  const allUnfilteredFeatureGroups = _.sortBy(_.union(unfilteredFeatureGroups, pendingFeatureGroups),
    a => _.trim(a.name).toLowerCase())
    .filter(g => !_.isEmpty(g.features) && g.enabled);
  const { groups, featuresMap } = groupFeaturesWithinGroups(allUnfilteredFeatureGroups);

  return {
    edit,
    installationDDL: selectors.getInstallationDDL(state),
    filterGroups: selectors.getFilterGroups(state),
    hasKitchen: auth.hasKitchenSub,
    hasBathroom: auth.hasBathroomSub,
    hasFireplace: auth.hasFireplaceSub,
    hasLaundryRoom: auth.hasLaundryRoomSub,
    // featureList,
    featureGroups: allFeatureGroups,
    unfilteredFeatureGroups: groups,
    featuresMap,
    group: {
      name: featuresCreatorNew.activeFeaturesGroupName
    },
    AR: AccessRights.get(state),
    featureDefinitionId: state.newFeature.featureDefinitionId,
    catId: state.routing.locationBeforeTransitions.query.catId,
    categoriesVisualizer: state.newScope.categoriesVisualizer,
    // groupedFeaturesByName: (edit && edit.groupedFeaturesByName) || []
  };
}

const mapDispatchToProps = (dispatch, props) => {
  return {
    showLoadingDialog: (show, title, text) => dispatch(loadingDialog_show(show, title, text)),
    onSave: (data) => dispatch(saveFeature(data)),
    onCancel: () => {
      dispatch(resetFeatureData());
      dispatch(showNewFeatureOverlay(false));
    },
    //loadFeatures: (groupName, catId) => dispatch(A.loadFeatures(groupName, catId)),
    showErrorBox: (title, text) => dispatch(messageBox_Show(true, 'error', title, text)),
    getFeatureData: (featureDefinitionId, catId) => dispatch(getFeatureData(featureDefinitionId, catId)),
    getFeatureDataRelated: () => dispatch(getFeatureDataRelated()),
    resetFeatureData: () => dispatch(resetFeatureData())
  }
}

const relatedFeaturesFilter = feature => {
  return feature.fabricatorData
    && feature.enabled
    && feature.fabricatorData.enabled
    && !feature.name.toLowerCase().includes('placeholder');
};

const featureRegex = /(.*?s?)(?:-x)?\s*-\s*([\s\w]+)\s*([\[\(]+.*[]\)]+)*/i;
const groupFeaturesWithinGroups = groups => {
  const featuresMap = {};
  groups.forEach(group => {
    if (!_.isEmpty(group.features)) {
      group.features = _.filter(group.features, f => relatedFeaturesFilter(f));

      group.features.forEach(feature => {
        featuresMap[feature.fabricatorData.id] = feature;
        const match = featureRegex.exec(feature.name);
        if (match && match.length >= 2) {
          feature.nakedName = match[2].toLowerCase();
          feature.originalNakedName = match[2];
          feature.nakedGroupName = match[1];
          feature.unparsable = false;
          feature.group = group; // remember the parent group
        } else {
          feature.unparsable = true;
        }
      });

      group.groupedFeatures = _.groupBy(group.features, _ => _.nakedName);
    }
  });

  return { groups, featuresMap };
}

const formatDisplayLogicRules = (rules, featureList) => {
  let formattedRules = [];
  if (rules && rules.length > 0) {
    rules.forEach(r => {
      formattedRules.push({
        id: r.id,
        showDDL: false,
        showComparisonDDL: false,
        comparisonFor: _.find(featureList, f => f.value === r.entityId),
        comparison: _.find(DisplayLogicComparisonOptions, d => d.value === r.comparison),
        value: r.value
      });
    })
  }
  return formattedRules;
}

const canGroupHaveMeta = (group, meta) => {
  switch (_.trim(group).toLowerCase()) {
    case "vanity":
      return meta === "custom_complete";
    case "bathtub":
      return meta === "fixture";
    case "shower":
      return meta === "size";
    case "sink":
      return meta === "size";
    case "countertop":
    case "faucet":
      return meta === "custom_complete" || meta === "size";
  }
  return false;
}

const buildMetaData = (group, state) => {
  const metaData = Object.assign({}, state.metaData);
  switch (_.trim(group).toLowerCase()) {
    case "vanity":
      if (state.metaComplete) {
        metaData.complete = ['true'];
        if (metaData.custom) delete metaData.custom;
      }
      if (state.metaCustom) {
        metaData.custom = ['true'];
        if (metaData.complete) delete metaData.complete;
      }
      break;
    case "bathtub":
      if (metaData.fixture && !state.metaFixtureOff) delete metaData.fixture;
      if (state.metaFixtureOff)
        metaData.fixture = ["Off"];
      break;
    case "shower":
      metaData.size = _.map(state.metaSizes, s => s + "in");
      break;
    case "sink":
    case "faucet":
      metaData.vanitySize = _.map(state.metaSizes, s => s + "in");
      metaData.off = state.metaAllSizes.filter(s => state.metaSizes.indexOf(s) === -1);
      break;
    case "countertop":
      metaData.vanity = [];
      if (state.metaComplete) metaData.vanity.push("Complete");
      if (state.metaCustom) metaData.vanity.push("Custom");
      if (_.trim(group).toLowerCase() === "faucet")
        break;

      metaData.countertopSize = _.map(state.metaSizes, ms => ms + "in");
      break;
  }
  return metaData;
}

const buildName = (group, state, metaSizeList) => {
  console.log("buildName FUNCTION DEPRECIATED");
  return state.name;
}

const MapSizeArray = (sizes) => sizes.map(s => {
  return (typeof s === "number") ? s : parseInt(s.replace(/[^0-9]/g, ''))
});

class NewFeatureOverlayClass extends PureComponent {

  updateTimeout = null;

  state = {
    isLoading: false,
    featureList: [],
    displayLogicRules: [],
    searchFiltersText: ""
  };

  constructor(props) {
    super(props);
    this.setStateFromProps(props, true);
    this.scrollableBreadcrumbContainer = createRef();
  }

  componentDidMount() {
    document.addEventListener('post-save-transient', this.allowUpdate);
    this.autosize();
    if (this.props.featureDefinitionId) {
      this.setState({
        isLoading: true
      });
      this.props.getFeatureData(this.props.featureDefinitionId, this.props.catId)
        .then(displayLogicFeatures => {
          // console.log("displayLogicFeatures", displayLogicFeatures);
          if (displayLogicFeatures != null) {
            const featureList = [{ text: "Material", value: "-1" }, ...displayLogicFeatures.filter((feature) => {
              return feature.text && !feature.text.includes("Part2") && !feature.text.includes("PartN") && !feature.text.includes("laceholder")
            })];
            this.setState({
              isLoading: false,
              featureList,
              displayLogicRules: formatDisplayLogicRules(this.props.edit.displayLogicRules, featureList)
            });
            this.setStateFromProps(this.props);
            this.autosize();
          }
          else {
            this.setState({
              isLoading: false
            }, this.props.onCancel);
          }
        });

      this.setState({
        ...this.state,
        relatedLoading: true
      });
      this.props.getFeatureDataRelated().then(() => {
        this.setState({
          ...this.state,
          relatedLoading: false
        });
        this.setRelatedStateFromProps(this.props);
      });


    } else if (!this.props.filterGroups.length) {
      getAllFilterGroups()
    }
  };

  componentWillUnmount() {
    document.removeEventListener('post-save-transient', this.allowUpdate);
  }

  componentWillReceiveProps(newProps) {
    if (this.state.allowUpdate) {
      if (this.updateTimeout)
        window.clearTimeout(this.updateTimeout);
      this.updateTimeout = window.setTimeout(() => this.setStateFromProps(newProps), 100);
    }
  }

  toggleStateKey = (tool, key) => {
    let toolSettings = [...this.state.toolSettings];
    let found = false;
    for (var idx in toolSettings) {
      var ts = toolSettings[idx];
      if (ts.tool == tool) {
        found = true;
        ts[key] = !ts[key];
      }
    }
    if (!found) {
      toolSettings.push({
        tool,
        [key]: true,
        fabricatorFeatureId: this.state.id
      });
    }
    this.setState({ toolSettings });
  };

  toggleSetting = (key) => {
    this.setState({ ...this.state, [key]: !this.state[key] });
  };

  hasVisibility = (tool, key) => {
    if (this.state.toolSettings) {
      for (var idx in this.state.toolSettings) {
        var ts = this.state.toolSettings[idx];
        if (ts.tool == tool) {
          return ts[key];
        }
      }
    }
    return false;
  };

  setStateFromProps = (props, init = false) => {
    const edit = props.edit || {};
    const { isServerData } = props;
    var re = new RegExp(props.group.name.toLowerCase() + " - ", "gi");
    let name = edit.name ? _.trim(edit.name.replace(re, "")) : '';

    let splitName = isServerData ? null : /(.*)(\[.*\])/gi.exec(name);
    let metaCustom = false
      , metaComplete = false
      , metaSize = false
      , metaFixtureOff = false
      , meta = ""
      , showMetaCustomComplete = canGroupHaveMeta(props.group.name, "custom_complete")
      , showMetaSize = canGroupHaveMeta(props.group.name, "size")
      , showMetaFixtureOff = canGroupHaveMeta(props.group.name, "fixture")
      , showMetaOptions = showMetaCustomComplete || showMetaSize || showMetaFixtureOff
      , metaSizes = []
      , metaAllSizes = [];

    if (edit.metaData) {
      metaCustom = (edit.metaData.custom && edit.metaData.custom[0]) || false;
      metaComplete = (edit.metaData.complete && edit.metaData.complete[0]) || false;

      if (edit.metaData.vanity) {
        metaCustom = edit.metaData.vanity.indexOf("Custom") >= 0;
        metaComplete = edit.metaData.vanity.indexOf("Complete") >= 0;
      }

      if (edit.metaData.vanitySize) {
        metaSizes = MapSizeArray(edit.metaData.vanitySize);
      } else if (edit.metaData.countertopSize) {
        metaSizes = MapSizeArray(edit.metaData.countertopSize);
      } else if (edit.metaData.size) {
        metaSizes = MapSizeArray(edit.metaData.size);
      }
      // console.log(metaSizes);
      if (edit.metaData.off) {
        metaAllSizes = metaSizes.concat(MapSizeArray(edit.metaData.off)).sort();
      } else {
        metaAllSizes = CabinetSizes;
      }
      metaSize = _.isEmpty(metaSizes);
      metaFixtureOff = edit.metaData.fixture && edit.metaData.fixture[0].toLowerCase() === "off";
      if (splitName && splitName[2]) {
        name = splitName[1];
      }
    } else {
      if (splitName && splitName[2]) {
        name = splitName[1];
        meta = splitName[2];
        let meta_l = meta.toLowerCase();
        metaCustom = meta_l.includes("custom");
        metaComplete = meta_l.includes("complete");
        metaSize = meta_l.includes("size");
        if (metaSize) {
          let size_l = /size=(.*?)[\;|\]=]/gi.exec(meta_l);
          if (size_l && size_l.length >= 1) {
            CabinetSizes.forEach(size => {
              if (size_l[0].includes(size))
                metaSizes.push(size);
            });
          }
        }
        metaFixtureOff = meta_l.includes('fixture=off')
      }
    }

    const RF = {
      features: [],
      activeGroup: null
    };
    console.log(458, props);
    if (!_.isEmpty(edit.relatedFeatures)) {
      if(props.unfilteredFeatureGroups && props.unfilteredFeatureGroups.forEach) {
        props.unfilteredFeatureGroups.forEach(fg => {
          const rf = (fg.features || fg.values)
            .flatMap(feat => feat.fabricatorData ? feat.fabricatorData.id : feat.id)
            .filter(featId => edit.relatedFeatures.includes(featId));
          if (_.size(rf)) {
            if (!RF.activeGroup)
              RF.activeGroup = fg;
            RF.features = RF.features.concat(rf);
          }
        });
      }
    }

    const BF = {
      features: [],
      activeGroup: null
    };
    if (!_.isEmpty(edit.bundledFeatures)) {
      if(props.unfilteredFeatureGroups && props.unfilteredFeatureGroups.forEach) {
        props.unfilteredFeatureGroups.forEach(fg => {
          const bf = (fg.features || fg.values)
            .flatMap(feat => feat.fabricatorData ? feat.fabricatorData.id : feat.id)
            .filter(featId => edit.bundledFeatures.includes(featId));
          if (_.size(bf)) {
            if (!BF.activeGroup)
              BF.activeGroup = fg;
            BF.features = BF.features.concat(bf);
          }
        });
      }
    }

    const allUnitMeasurementOptions = (edit.unit ? [...new Set([edit.unit, ...UNIT_MEASUREMENTS])] : [...UNIT_MEASUREMENTS])
      .map(option => ({
        value: option,
        text: option
      }));

    let newState = {
      id: edit.id || 0,
      step: props.hasUnlinkedData ? Steps.ComplexLogic : Steps.Installation,
      canSave: props.edit,
      allowUpdate: false, //allow update from props when new props received
      //----ASIDE
      showUnitDDL: false,
      units: allUnitMeasurementOptions,
      name,
      meta,
      sku: edit.sku || '',
      model: edit.model || '',
      description: edit.description || '',
      subDescription: edit.subDescription || '',
      unit: edit.unit || allUnitMeasurementOptions[0].value,
      toolSettings: edit.toolSettings || [],
      showMetaOptions,
      showMetaCustomComplete,
      showMetaSize,
      showMetaFixtureOff,
      hideUnitLabel: edit.hideUnitLabel || false,
      productNotForSale: edit.productNotForSale || false,
      autoAddToCart: edit.autoAddToCart || false,
      notTaxable: edit.notTaxable || false,
      priceEditable: edit.priceEditable || false,
      employeesOnly: edit.employeesOnly || false,
      hideQuantity: edit.hideQuantity || false,
      defaultQuantity: edit.defaultQuantity || 1,
      useStonePricing: edit.useStonePricing === null ? true : edit.useStonePricing,
      thumbnailImage: null,
      thumbnailImageUrl: edit.thumbnailImageUrl || null,
      metaCustom,
      metaComplete,
      metaSizes,
      metaAllSizes,
      metaFixtureOff,
      metaData: edit.metaData,
      //----INSTALLATION
      installations: this.formatInstallations(edit.installations),
      //----FILTERS
      selectedFilterCategory: null,
      selectedFilters: edit.selectedFilters || [],
      defaultFilters: edit.defaultFilters,
      featDefFilters: _.map(edit.featDefFilters, 'filterGroupValue_id'),
      fabricatorOverrideEnabledFilters: edit.fabricatorOverrideEnabledFilters || [],
      //----GALLERY
      galleryEnabled: edit.galleryEnabled || false,
      galleryImages: edit.galleryImages || [],
      //----COMPLEX LOGIC
      complexLogic: edit.complexLogic || '',
      //----DISPLAY LOGIC
      displayLogicEnabled: edit.displayLogicEnabled || false,
      displayLogicAction: edit.displayLogicAction || 'show',
      displayLogicActionDDLVisible: false,
      // matching products
      groupedFeaturesByName: this.props.matchingProducts || this.props.edit && this.props.edit.groupedFeaturesByName.map(f => ({
        id: f.id,
        cost: f.fabricatorData ? f.fabricatorData.cost : 0,
        groupName: f.nakedGroupName,
        unlocked: f.fabricatorData ? f.fabricatorData.unlocked : false,
        metaData: (f.fabricatorData ? f.fabricatorData.metaData : null) || (f.metaData || {}),
        name: f.originalNakedName
      })),
      // --- RELATED FEATURES
      relatedFeatures: {
        productFilter: '',
        productSortBy: PRODUCT_SORT_OPTIONS.Name,
        sortOptionsVisible: false,
        selectedFilters: [],
        expandedFilters: [],
        colorFilterOptionsVisible: false,
        materialFilterOptionsVisible: false,
        allFilterOptionsVisible: false,
        materialFilterOptions: [],
        colorFilterOptions: [],
        allFilterOptions: [],
        activeGroup: RF.activeGroup,
        features: RF.features
      },
      bundledFeatures: {
        productFilter: '',
        productSortBy: PRODUCT_SORT_OPTIONS.Name,
        sortOptionsVisible: false,
        selectedFilters: [],
        expandedFilters: [],
        colorFilterOptionsVisible: false,
        materialFilterOptionsVisible: false,
        allFilterOptionsVisible: false,
        materialFilterOptions: [],
        colorFilterOptions: [],
        allFilterOptions: [],
        activeGroup: BF.activeGroup,
        features: BF.features
      }
    };

    if (edit.unlinkedData) {
      if (edit.unlinkedData.complexLogic && edit.unlinkedData.complexLogic.length > 0) {
        newState.complexLogic = edit.unlinkedData.complexLogic;
      }
      if (edit.unlinkedData.displayName) {
        newState.name = edit.unlinkedData.displayName;
      }
      if (edit.unlinkedData.hideFromKVQT) {
        newState.forQuotingTool = !edit.unlinkedData.hideFromKVQT
      }
      if (edit.unlinkedData.hideFromKV) {
        newState.forKitchenVisualizer = !edit.unlinkedData.hideFromKV
      }
      if (edit.unlinkedData.hideFromBVQT) {
        newState.forBathroomQuotingTool = !edit.unlinkedData.hideFromBVQT
      }
      if (edit.unlinkedData.hideFromBV) {
        newState.forBathroomVisualizer = !edit.unlinkedData.hideFromBV
      }
    }

    if (init) {
      this.state = newState;
    } else {
      this.setState({ ...this.state, ...newState });
    }
  }

  setRelatedStateFromProps = (props) => {
    const edit = props.edit || {};

    const RF = {
      features: [],
      activeGroup: null
    };
    if (!_.isEmpty(edit.relatedFeatures)) {
      props.unfilteredFeatureGroups.forEach(fg => {
        const rf = (fg.features || fg.values)
          .flatMap(feat => feat.fabricatorData ? feat.fabricatorData.id : feat.id)
          .filter(featId => edit.relatedFeatures.includes(featId));
        if (_.size(rf)) {
          if (!RF.activeGroup)
            RF.activeGroup = fg;
          RF.features = RF.features.concat(rf);
        }
      });
    }

    const BF = {
      features: [],
      activeGroup: null
    };
    if (!_.isEmpty(edit.bundledFeatures)) {
      props.unfilteredFeatureGroups.forEach(fg => {
        const bf = (fg.features || fg.values)
          .flatMap(feat => feat.fabricatorData ? feat.fabricatorData.id : feat.id)
          .filter(featId => edit.bundledFeatures.includes(featId));
        if (_.size(bf)) {
          if (!BF.activeGroup)
            BF.activeGroup = fg;
          BF.features = BF.features.concat(bf);
        }
      });
    }

    let newState = {
      //--- RELATED FEATURES
      relatedFeatures: {
        productFilter: '',
        productSortBy: PRODUCT_SORT_OPTIONS.Name,
        sortOptionsVisible: false,
        selectedFilters: [],
        expandedFilters: [],
        colorFilterOptionsVisible: false,
        materialFilterOptionsVisible: false,
        allFilterOptionsVisible: false,
        materialFilterOptions: [],
        colorFilterOptions: [],
        allFilterOptions: [],
        activeGroup: RF.activeGroup,
        features: RF.features
      },
      bundledFeatures: {
        productFilter: '',
        productSortBy: PRODUCT_SORT_OPTIONS.Name,
        sortOptionsVisible: false,
        selectedFilters: [],
        expandedFilters: [],
        colorFilterOptionsVisible: false,
        materialFilterOptionsVisible: false,
        allFilterOptionsVisible: false,
        materialFilterOptions: [],
        colorFilterOptions: [],
        allFilterOptions: [],
        activeGroup: BF.activeGroup,
        features: BF.features
      }
    }

    this.setState({ ...this.state, ...newState });
  }

  getNextStep = (step, prev = false) => {
    let steps = _.keyBy(Steps, s => s.step);
    for (let key in steps) {
      if (key > step.step && (
        !steps[key].adminOnly || this.props.AR.isSiteAdmin(true)
      )) {
        return steps[key];
      }
    }
    return Steps.GroupedFeaturesByName;
  }

  getPrevStep = (step, prev = false) => {
    let steps = [];
    for (let _step in Steps) {
      steps.unshift(Steps[_step]);
    }
    for (let key in steps) {
      if (steps[key].step < step.step && (
        !steps[key].adminOnly || this.props.AR.isSiteAdmin(true)
      )) {
        return steps[key];
      }
    }
    return Steps.Installation;
  }

  updateAssocFeatureProp = (featureId, propName, propValue) => {
    const { associatedFeatures } = this.state;
    const f = _.find(associatedFeatures, { id: featureId });
    f[propName] = propValue;
    this.setState({ associatedFeatures: [...associatedFeatures] });
  }

  updateGroupedFeatureByNameProp = (featureId, propName, propValue) => {
    const { groupedFeaturesByName } = this.state;
    const f = _.find(groupedFeaturesByName, { id: featureId });
    f[propName] = propValue;
    this.setState({ groupedFeaturesByName: [...groupedFeaturesByName] });
  }

  autosize = () => {
    let el = this.autoSizeTextArea;
    setTimeout(function () {
      let lines = el.value.split('\n');
      if (lines.length > 5) {
        el.value = lines.slice(0, 5).join('\n');
      }
      el.style.cssText = 'height:20px; padding:0';
      // for box-sizing other than "content-box" use:
      // el.style.cssText = '-moz-box-sizing:content-box';
      el.style.cssText = 'height:' + el.scrollHeight + 'px';
    }, 0);
  }

  getMetaCustomCompleteItems = () => {
    return [
      { text: 'Custom Vanity', value: 'custom', selected: this.state.metaCustom },
      { text: 'Complete Vanity', value: 'complete', selected: this.state.metaComplete }
    ];
  }

  getMetaSizeItems = () => {
    let sizeOptions = this.state.metaAllSizes;
    let sizes = [];
    if (this.props.group.name.toLowerCase().includes('shower')) {
      sizeOptions = ShowerSizes;
    }
    sizeOptions.forEach(size => sizes.push({
      text: size + " Inches",
      value: size,
      type: 'size',
      selected: this.state.metaSizes.indexOf(size) >= 0
    }));
    return sizes;
  }

  handleSelection = (val, items) => {
    let metaCustom = this.state.metaCustom
      , metaComplete = this.state.metaComplete
      , metaSizes = this.state.metaSizes
      , metaFixtureOff = this.state.metaFixtureOff;
    if (val && val.type && val.type === "size") {
      metaSizes = [];
    }
    items.forEach(i => {
      switch (i.value) {
        case 'custom':
          metaCustom = i.selected;
          break;
        case 'complete':
          metaComplete = i.selected;
          break;
        case 'fixture':
          metaFixtureOff = i.selected;
          break;
        default:
          if (i.type === "size" && i.selected)
            metaSizes.push(i.value);
          break;
      }
    });
    this.setState({ metaComplete, metaCustom, metaSizes, metaFixtureOff });
  }

  getSelectedItemByValue = (list, value) => {
    if (list && list.length > 0) {
      let v = _.find(list[0].items ? _.flatMap(list, l => l.items) : list, l => l.value === value);
      if (!v) {
        v = _.first(list);
      }
      return v;
    }
    return {
      text: "No Options Available",
      value: 0
    };
  }

  getSelectedInstallationByInstallationDefinitionId = (instDefId) => {
    let items = _.flatMap(this.props.installationDDL, iddl => iddl.items);
    let selected = _.find(items, i => i.value.fabricatorInstallation_id === instDefId);
    if (!selected) {
      selected = _.first(items);
    }
    return selected;
  }

  formatInstallations = (installations) => {
    let formattedInstallations = [];
    if (!_.isEmpty(installations)) {
      installations.forEach(i => {
        formattedInstallations.push({
          fabricatorInstallation_id: i,
          showDDL: false,
          selected: this.getSelectedInstallationByInstallationDefinitionId(i)
        });
      });
    }
    return formattedInstallations;
  }

  handleSave = () => {
    const { isServerData } = this.props;

    let relatedFeatures = [];
    if (!isServerData) {
      // this has only the first features from the same group of features with same name
      const relFeatures = this.state.relatedFeatures.features;
      _.forEach(relFeatures.map(f => this.props.featuresMap[f]), f => {
        const { group } = f;
        const featuresWithSameName = group.groupedFeatures[f.nakedName];
        relatedFeatures = relatedFeatures.concat(featuresWithSameName.map(_ => _.fabricatorData.id));
      });
    } else {
      relatedFeatures = relatedFeatures.concat(this.state.relatedFeatures.features);
    }

    relatedFeatures = _.flatten(relatedFeatures);

    let bundledFeatures = [];
    if (!isServerData) {
      // this has only the first features from the same group of features with same name
      const bunFeatures = this.state.bundledFeatures.features;
      _.forEach(bunFeatures.map(f => this.props.featuresMap[f]), f => {
        const { group } = f;
        const featuresWithSameName = group.groupedFeatures[f.nakedName];
        bundledFeatures = bundledFeatures.concat(featuresWithSameName.map(_ => _.fabricatorData.id));
      });
    } else {
      bundledFeatures = bundledFeatures.concat(this.state.bundledFeatures.features);
    }

    bundledFeatures = _.flatten(bundledFeatures);

    let data = {
      id: this.state.id,
      catId: this.props.catId || 0,
      group: this.props.group.name,
      name: this.state.name,
      metaData: JSON.stringify(buildMetaData(this.props.group.name, this.state)),
      sku: this.state.sku,
      model: this.state.model,
      description: this.state.description,
      subDescription: this.state.subDescription,
      unit: this.state.unit,
      forQuotingTool: this.state.forQuotingTool,
      forKitchenVisualizer: this.state.forKitchenVisualizer,
      forBathroomVisualizer: this.state.forBathroomVisualizer,
      forBathroomQuotingTool: this.state.forBathroomQuotingTool,
      toolSettings: this.state.toolSettings,
      hideUnitLabel: this.state.hideUnitLabel,
      productNotForSale: this.state.productNotForSale,
      autoAddToCart: this.state.autoAddToCart,
      notTaxable: this.state.notTaxable,
      priceEditable: this.state.priceEditable,
      useStonePricing: this.state.useStonePricing,
      employeesOnly: this.state.employeesOnly,
      hideQuantity: this.state.hideQuantity,
      defaultQuantity: this.state.defaultQuantity,
      thumbnailImageName: this.state.thumbnailImage && this.state.thumbnailImage.name,
      thumbnailImageUrl: this.state.thumbnailImageUrl,
      installations: _.map(this.state.installations, i => i.fabricatorInstallation_id),
      filters: this.state.selectedFilters,
      fabricatorOverrideEnabledFilters: this.state.fabricatorOverrideEnabledFilters,
      galleryEnabled: this.state.galleryEnabled,
      galleryImages: this.state.galleryImages,
      complexLogic: this.state.complexLogic,
      displayLogicEnabled: this.state.displayLogicEnabled,
      displayLogicAction: this.state.displayLogicAction,
      displayLogicRules: _.map(this.state.displayLogicRules, dlr => ({
        id: dlr.id,
        fabricatorFeature_id: dlr.comparisonFor ? dlr.comparisonFor.value : 0,
        comparison: dlr.comparison.value,
        value: dlr.value
      })),
      associatedFeatures: this.state.associatedFeatures,
      groupedFeaturesByName: this.state.groupedFeaturesByName,  // matching products
      relatedFeatures,
      bundledFeatures,
      bundledFeaturesQuantities: this.props.bundledFeaturesQuantities,
      visualizerType: this.props.categoriesVisualizer,
    }

    this.setState({ nameError: null, descError: null, thumbError: null }, () => {
      let errors = [];
      if (_.trim(data.name).length === 0)
        errors.push(this.addError('name', 'Product Name is required'));
      if (this.props.categoriesVisualizer !== AVAILABLE_VISUALIZERS.leadform) {
        if (_.trim(data.description).length === 0)
          errors.push(this.addError('desc', 'Product Description is Required'));
        if (_.trim(data.thumbnailImageUrl).length === 0) {
          errors.push(this.addError("thumb", "Product Thumbnail is Required"));
        }
      }

      if (errors.length > 0) {
        Promise.all(errors);
      } else {
        this.props.onSave(data);
        this.props.onCancel();
      }
    });
  }

  checkCanSave = () => {
    this.setState({ canSave: this.canSave() });
  }

  getNeededFiltersConditions = () => {
    const notSelectedFilters = [];
    const countertopGroup = ["Backsplash", "Center Island Countertop", "Countertop"];
    if (countertopGroup.includes(this.props.group.name)) {
      const neededFilters = ["Center Island Countertop", "Countertop"].includes(this.props.group.name)
        ? ["Manufacturer", "Countertop Material"]
        : ["Manufacturer", "Material"]
      neededFilters.forEach(filterGroupName => {
        const filterGroup = this.props.filterGroups.find(filterGroup => {
          return filterGroup.name.trim() === filterGroupName
        });
        const conditionPassed = filterGroup && filterGroup.values.some(filter => {
          const sheckedState = this.getCheckFilterState(filter);
          return sheckedState === STATES.Checked || sheckedState === STATES.Other
        })
        if (!conditionPassed) {
          notSelectedFilters.push(filterGroupName.trim())
        }
      })
    }
    // console.log("notSelectedFilters", notSelectedFilters);
    return notSelectedFilters
  };

  canSave = () => {
    // return this.state.step.step >= Steps.Gallery.step || ( // why we can save if step is bigger than gallery?
    let conditions = [
      _.trim(this.state.name).length > 0,
    ];
    if (this.props.categoriesVisualizer !== AVAILABLE_VISUALIZERS.leadform) {
      conditions = [
        ...conditions,
        _.trim(this.state.description).length > 0,
        _.trim(this.state.thumbnailImageUrl).length > 0,
        !this.getNeededFiltersConditions().length
      ]
    }
    return conditions.every(cond => cond)
  }

  addError = (on, msg) => {
    return new Promise(resolve => {
      this.setState({ [on + 'Error']: msg }, resolve);
    });
  }

  //#region Aside Functions
  addNewUnit = (unit) => {
    this.setState({ units: [{ text: unit, value: unit }, ...this.state.units], unit, showUnitDDL: false });
  };

  onDrop = (file) => {
    this.props.showLoadingDialog(true, "Loading Image...", "Scanning/Loading image, this should only take a moment...")
      .then(() => {
        this.props.showLoadingDialog(false);
        const img = new Image();
        img.onload = () => {
          const height = img.height;
          const width = img.width;
          const warnings = [], errors = [];
          if (height - width !== 0) {
            warnings.push('Image height and width are not equal.  Stone images work best if they are square.');
          }
          if (height > 3840 || width > 3840) {
            warnings.push('Image dimensions are exceeding 3840 pixels in either height or width');
          }
          if (file[0].size > 262144) {
            warnings.push('Image size is exceeding 256kb in size.');
          } else if (file[0].size > 4194304) {
            errors.push('Image size is exceeding 4MB in size.');
          }
          if (errors.length > 0) {
            this.props.showErrorBox('Unable to use Image', errors.join('<br />'));
          } else {
            const f = new FileReader();
            f.onload = (e) => this.setState({
              thumbnailImageUrl: e.target.result,
              thumbnailImage: file[0]
            }, () => this.setState({ canSave: this.canSave() }));
            f.readAsDataURL(file[0]);
          }
        }
        if (file && file.length >= 1 && file[0].preview) {
          img.src = file[0].preview;
        } else {
          this.props.showErrorBox("Unable to use Image", "Unrecognized image format, please use a JPEG or PNG image.");
        }
      });
  }
  //#endregion
  //#region Installation Functions

  handleAddInstallation = () => {
    let installations = [...this.state.installations];
    var selected = this.getSelectedInstallationByInstallationDefinitionId(0);
    if (!selected) {
      return
    }
    installations.unshift({
      fabricatorInstallation_id: selected.value.fabricatorInstallation_id,
      showDDL: false,
      selected: selected
    });
    this.setState({ installations });
  }

  handleUpdateInstallation = (installation, key, value) => {
    let installations = [...this.state.installations]
      , index = _.findIndex(installations, i => i === installation);
    if (index >= 0) {
      installations[index][key] = value;
      if (key === "fabricatorInstallation_id") {
        installations[index].selected = this.getSelectedInstallationByInstallationDefinitionId(value.fabricatorInstallation_id);
        installations[index][key] = value.fabricatorInstallation_id;
      }
    }
    this.setState({ installations }, this.forceUpdate);
  }

  handleDeleteInstallation = (installation) => {
    let installations = [...this.state.installations]
      , index = installations.indexOf(installation);
    if (index >= 0)
      installations.splice(index, 1);
    this.setState({ installations })
  }

  //#endregion
  //#region Filter Functions
  filterGroupHasFilters = (filterGroup) => {
    return filterGroup && filterGroup.values.some(filter => {
      const sheckedState = this.getCheckFilterState(filter);
      return sheckedState === STATES.Checked || sheckedState === STATES.Other
    })
  };
  isFilterSelected = (filter, selectedFilters = this.state.selectedFilters) => {
    return selectedFilters.indexOf(filter.id) >= 0 || !!_.find(this.state.defaultFilters, df => df.filterGroupValue_id === filter.id);
  }
  isDefaultFilter = (filter) => {
    return !!_.find(this.state.defaultFilters, df => df.filterGroupValue_id === filter.id);
  }
  handleToggleFilter = (filter) => {
    let selectedFilters = [...this.state.selectedFilters]
      , fabricatorOverrideEnabledFilters = [...this.state.fabricatorOverrideEnabledFilters]
      , index = selectedFilters.indexOf(filter.id);

    if (index >= 0) { // filter already selected
      selectedFilters.splice(index, 1);
      if (this.state.featDefFilters.indexOf(filter.id) > -1) {
        fabricatorOverrideEnabledFilters.push(filter.id);
      }
    } else {
      if (this.state.selectedFilterCategory.name.trim().toLowerCase() === "brand") {
        this.state.selectedFilterCategory.values.forEach((currentFilter) => {
          const otherValueSelectedIndex = selectedFilters.indexOf(currentFilter.id);
          if (otherValueSelectedIndex > -1) {
            selectedFilters.splice(otherValueSelectedIndex, 1); // remove other brand filters
          }
          const otherValueSelectedIndex2 = fabricatorOverrideEnabledFilters.indexOf(currentFilter.id);
          if (otherValueSelectedIndex2 > -1) {
            selectedFilters.splice(otherValueSelectedIndex2, 1); // remove other brand filters
          }
        })
      }
      let deletedIndex = fabricatorOverrideEnabledFilters.indexOf(filter.id);
      if (deletedIndex > -1) {
        fabricatorOverrideEnabledFilters.splice(index, 1);
      } else {
        selectedFilters.push(filter.id);
      }
    }
    this.setState({ selectedFilters, fabricatorOverrideEnabledFilters }, this.checkCanSave);
  }
  getCheckFilterState = (filter) => {
    if (!this.isFilterSelected(filter) && this.state.featDefFilters.indexOf(filter.id) > -1 && this.state.fabricatorOverrideEnabledFilters.indexOf(filter.id) == -1) {
      return STATES.Other;
    } else if (this.isFilterSelected(filter)) {
      return STATES.Checked;
    }
    return STATES.UnChecked;
  }
  //#endregion
  //#region Gallery Functions
  onGalleryDrop = (files) => {
    this.props.showLoadingDialog(true, "Loading Image...", "Scanning/Loading image, this should only take a moment...")
      .then(() => {
        this.props.showLoadingDialog(false);
        let galleryImages = this.state.galleryImages || [];
        files.forEach(file => {
          let img = new Image();
          img.onload = () => {
            let errors = [];
            if (file.size > 4194304) {
              errors.push('Image ' + file.name + ' size is exceeding 4MB in size.');
            }
            if (errors.length > 0) {
              this.props.showErrorBox('Unable to use Image', errors.join('<br />'));
            } else {
              var f = new FileReader();
              f.onload = (e) => {
                galleryImages.push({
                  id: 0,
                  name: file.name,
                  url: e.target.result,
                  default: false,
                  featured: false
                })
                this.setState({ galleryImages }, this.forceUpdate);
              };
              f.readAsDataURL(file);
            }
          }
          if (file && file.preview) {
            img.src = file.preview;
          } else {
            this.props.showErrorBox("Unable to use Image " + file.name, "Unrecognized image format, please use a JPEG or PNG image.");
          }
        });
      });
  }

  handleMakeDefault = (image) => {
    let galleryImages = [...this.state.galleryImages];
    galleryImages.forEach(i => i.default = false);
    galleryImages[galleryImages.indexOf(image)].default = true;
    this.setState({ galleryImages });
  }

  handleDeleteGalleryImage = (image) => {
    let galleryImages = [...this.state.galleryImages];
    galleryImages.splice(galleryImages.indexOf(image), 1);
    this.setState({ galleryImages });
  }

  handleSetFeatured = (image) => {
    let galleryImages = [...this.state.galleryImages];
    let index = galleryImages.indexOf(image);
    galleryImages[index].featured = !galleryImages[index].featured;
    this.setState({ galleryImages });
  }
  //#endregion
  //#region Display Logic Functions
  handleUpdateDisplayLogicAction = (action) => this.setState({
    displayLogicAction: action,
    displayLogicActionDDLVisible: false
  })

  handleAddDisplayRule = () => {
    let displayLogicRules = [...this.state.displayLogicRules];
    displayLogicRules.unshift({
      id: 0,
      showDDL: false,
      showComparisonDDL: false,
      comparisonFor: this.state.featureList[0],
      comparison: DisplayLogicComparisonOptions[0],
      value: 0
    });
    this.setState({ displayLogicRules });
  }

  handleUpdateDisplayRule = (displayRule, key, value) => {
    let displayLogicRules = [...this.state.displayLogicRules]
      , index = displayLogicRules.indexOf(displayRule);

    if (index >= 0) {
      displayLogicRules[index][key] = value;
    }

    this.setState({ displayLogicRules });
  }

  handleDeleteDisplayRule = (displayRule) => {
    let displayLogicRules = [...this.state.displayLogicRules]
      , index = displayLogicRules.indexOf(displayRule);

    if (index >= 0) {
      displayLogicRules.splice(index, 1);
    }
    this.setState({ displayLogicRules });
  }

  handleUpdateDisplayRuleComparisonFor = (displayRule, value) => {
    let displayLogicRules = [...this.state.displayLogicRules]
      , index = displayLogicRules.indexOf(displayRule);
    if (index >= 0) {
      displayLogicRules[index].comparisonFor = _.find(this.state.featureList, fl => fl.value === value);
      displayLogicRules[index].showDDL = false;
    }
    this.setState({ displayLogicRules });
  }

  handleUpdateDisplayRuleComparison = (displayRule, value) => {
    let displayLogicRules = [...this.state.displayLogicRules]
      , index = displayLogicRules.indexOf(displayRule);
    if (index >= 0) {
      displayLogicRules[index].comparison = _.find(DisplayLogicComparisonOptions, dco => dco.value === value);
      displayLogicRules[index].showComparisonDDL = false;
    }
    this.setState({ displayLogicRules });
  }
  //#endregion

  allowUpdate = () => this.setState({ allowUpdate: true });

  setRfState = (obj, cb) => {
    const relatedFeatures = { ...this.state.relatedFeatures, ...obj };
    this.setState({ relatedFeatures }, cb);
  }

  setBfState = (obj, cb) => {
    const bundledFeatures = { ...this.state.bundledFeatures, ...obj };
    this.setState({ bundledFeatures }, cb);
  }

  refreshFilterIcons = () => {
    this.setRfState({
      materialFilterOptions: this.getMaterialFilterOptions(),
      colorFilterOptions: this.getColorFilterOptions(),
      allFilterOptions: this.getAllFilterOptions(),
      selectedFilters: [],
      expandedFilters: [],
      colorFilterOptionsVisible: false,
      materialFilterOptionsVisible: false,
      allFilterOptionsVisible: false,
      sortOptionsVisible: false,
      checkAllFeatures: false
    });


    this.setBfState({
      materialFilterOptions: this.getMaterialFilterOptions(),
      colorFilterOptions: this.getColorFilterOptions(),
      allFilterOptions: this.getAllFilterOptions(),
      selectedFilters: [],
      expandedFilters: [],
      colorFilterOptionsVisible: false,
      materialFilterOptionsVisible: false,
      allFilterOptionsVisible: false,
      sortOptionsVisible: false,
      checkAllFeatures: false
    });
  }

  getMaterialFilterOptions = () => this.getFilterOptions('Material');

  getColorFilterOptions = () => this.getFilterOptions("Color");

  getFilterOptions = (filterName) => {
    if (!this.state.activeGroup)
      return [];

    const filterGroups = this.props.filterGroups;
    let products = this.state.activeGroup.features
      , mfgs = filterGroups.filter(fg => fg.name.toLowerCase().includes(filterName.toLowerCase()));

    if (!products || !products.length)
      return [];

    let inUseFilters = this.getInUseFilters(mfgs, products);

    return _.uniqBy(inUseFilters, f => f.id);
  }

  getAllFilterOptions = () => {
    if (!this.state.relatedFeatures.activeGroup)
      return [];

    const filterGroups = this.props.filterGroups;
    let inUseFilters = []
      , products = this.state.relatedFeatures.features
      ,
      mfgs = filterGroups.filter(fg => !fg.name.toLowerCase().includes('material') && !fg.name.toLowerCase().includes('color'));

    var topList = [];
    inUseFilters = this.getInUseFilters(mfgs, products);

    let uniqueFilters = _.uniqBy(inUseFilters, f => f.id);

    mfgs.forEach(mfg => {
      let values = mfg.values.filter(v => _.map(uniqueFilters, u => u.id).indexOf(v.id) >= 0);
      if (values.length > 0) {
        topList.push({
          id: mfg.id,
          displayText: mfg.name,
          items: values
        });
      }
    });
    return topList;
  }

  getInUseFilters = (mfgs, products) => {
    let inUseFilters = [];
    mfgs.forEach(mfg => {
      products.forEach(p => {
        if (p.filters && p.filters.length > 0) {
          p.filters.forEach(f => {
            let filterValue = _.find(mfg.values, v => v.id === f.filterGroupValue_id);
            if (filterValue && inUseFilters.indexOf(filterValue) < 0) {
              inUseFilters.push(filterValue);
              return;
            }
            mfg.values.forEach(v => {
              let index = _.findIndex(v.items, i => i.id === f.filterGroupValue_id);
              if (index >= 0) {
                let item = v.items[index];
                let exMfg = _.find(inUseFilters, iuf => iuf.id === mfg.id);
                if (!exMfg) {
                  inUseFilters.push(v);
                  exMfg = mfg;
                }
                exMfg.items = exMfg.items || [];
                if (exMfg.items.indexOf(item) < 0)
                  exMfg.items.push(item);
              }
            })
          });
        }
      });
    });
    return inUseFilters;
  }

  getGroupsFeatures = (group) => {
    if (group && !_.isEmpty(group.features || group.values)) {
      let features = [];
      if (group.groupedFeatures) {
        _.forEach(group.groupedFeatures, (featuresFromGroup, nakedName) => {
          features.push(_.first(featuresFromGroup))
        });
      } else if (group.values) {
        features = features.concat(group.values);
      }
      return features.filter(f => !this.props.edit || this.props.edit.id !== (f.fabricatorData ? f.fabricatorData.id : f.id));
    }

    return [];
  }

  applyProductFilters = (features) => {
    const RF = this.state.relatedFeatures;
    const searchFilter = _.trim(RF.productFilter.toLowerCase());
    let _products = [];
    if (!_.isEmpty(features)) {
      _products = features.filter(feature => this.cleanProductName(feature).toLowerCase().includes(searchFilter));
    }

    if (!_.isEmpty(RF.selectedFilters)) {
      _products = _products.filter(p => {
        const filterIds = _.map(p.filters, f => f.filterGroupValue_id);
        for (let i = 0; i < RF.selectedFilters.length; i++) {
          if (filterIds.indexOf(RF.selectedFilters[i]) < 0) {
            return false;
          }
        }
        return true;
      });
    }

    return _products;
  }

  applyProductSort = (products) => {
    let _products = null;
    const RF = this.state.relatedFeatures;
    if (RF.productSortBy === PRODUCT_SORT_OPTIONS.Name) {
      _products = _.sortBy(products, a => _.trim(a.name.toLowerCase()));
    } else if (RF.productSortBy === PRODUCT_SORT_OPTIONS.Price) {
      _products = _.sortBy(products, [a => {
        if (a.fabricatorData)
          return a.fabricatorData.cost;
        return 0;
      }, a => _.trim(a.name.toLowerCase())]);
    }
    return _products;
  }

  cleanProductName = (feature) => {
    if (this.props.isServerData) {
      return feature.name;
    }

    const RF = this.state.relatedFeatures;
    return _.trim(feature.name.substring(RF.activeGroup.name.length + 2));
  }

  toggleFeature = (featureIds, feature, prop = this.state.relatedFeatures, setState = this.setRfState) => {
    let features = prop.features;
    let checked = features.some(sf => feature.id.indexOf(sf) !== -1);
    for (let i = featureIds.length - 1; i >= 0; i--) {
      let id = featureIds[i];
      let index = features.indexOf(id);
      if (index >= 0 && checked) {
        features.splice(index, 1);
      } else if (!checked) {
        features.push(id);
      }
    }
    setState({ features: [...features] });
  };

  allProductsClicked = (prop) => {
    let checkAllFeatures = !prop.checkAllFeatures;
    const features = [...prop.features];
    const visibleProducts = this.applyProductSort(this.applyProductFilters(this.getGroupsFeatures(prop.activeGroup)));
    _.each(visibleProducts, p => {
      for (let i = p.id.length - 1; i >= 0; i--) {
        let index = features.indexOf(p.id[i]);
        if (checkAllFeatures) {
          if (index < 0) {
            features.push(p.id[i]);
          }
        } else {
          if (index >= 0) {
            features.splice(index, 1);
          }
        }
      }
    });

    if (prop === this.state.relatedFeatures)
      this.setRfState({ checkAllFeatures, features }, this.forceUpdate);
    if (prop === this.state.bundledFeatures)
      this.setBfState({ checkAllFeatures, features }, this.forceUpdate);
  }

  handleSearchFiltersTextChange = (searchFiltersText) => {
    this.setState({
      searchFiltersText
    })
  };

  getSelectedFilterCategoryValues = () => {
    if (this.state.searchFiltersText) {
      const lowerCased = this.state.searchFiltersText.trim().toLowerCase();
      return this.state.selectedFilterCategory.values.filter((filterObject) => {
        return (filterObject.displayText && filterObject.displayText.toLowerCase().includes(lowerCased))
          || (filterObject.value && filterObject.value.toLowerCase().includes(lowerCased))
      })
    }
    return this.state.selectedFilterCategory.values
  };

  render() {
    return this.state.isLoading ? null : template.call(this)
  }
}

const connector = connect(mapStateToProps, mapDispatchToProps);
const NewFeatureOverlay = connector(NewFeatureOverlayClass);

NewFeatureOverlay.propTypes = {
  hasKitchen: PropTypes.bool,
  hasBathroom: PropTypes.bool
}

export { NewFeatureOverlay }
export default NewFeatureOverlay;
